import { Component, computed, inject } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DefinicjeParametrow } from '../../../../shared/enums/params-definition.enum';
import { firstValueFrom } from 'rxjs';
import { SpinnerService } from '../../../services/spinner.service';
import { DokumentApi } from '../../../../shared/services/api/dokument.api';
import { InfoDialog } from '../../../../shared/components/info-dialog/info-dialog';
import { SiteMap } from '../site-map/site-map';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-footer-popups',
  imports: [],
  templateUrl: './footer-popups.html',
  styleUrl: './footer-popups.scss',
})
export class FooterPopups {
  readonly #dialogService = inject(DialogService);
  readonly #spinnerService = inject(SpinnerService);
  readonly #dokumentApi = inject(DokumentApi);
  readonly #authService = inject(AuthService);

  DefinicjeParametrow = DefinicjeParametrow;

  readonly hasSession = computed(() => this.#authService.hasSession());
  readonly footerItems = computed(() => {
    const items = [
      { param: DefinicjeParametrow.STRONA_KONTAKT, title: 'Kontakt' },
      {
        param: DefinicjeParametrow.STRONA_POLITYKA_PRYWATNOSCI,
        title: 'Polityka prywatności',
      },
      {
        param: DefinicjeParametrow.STRONA_DEKLARACJA_DOSTEPNOSCI,
        title: 'Deklaracja dostępności',
      },
    ];

    if (this.hasSession()) {
      items.push({
        param: DefinicjeParametrow.STRONA_MAPA_SERWISU,
        title: 'Mapa serwisu',
      });
    }

    return items;
  });

  fetchParamDefinition(param: DefinicjeParametrow): Promise<string> {
    return firstValueFrom(this.#dokumentApi.getParamContent$(param))
      .then((resp) => {
        this.#spinnerService.hide();
        return resp;
      })
      .catch((_) => {
        this.#spinnerService.hide();
        return 'Błąd';
      });
  }

  onListOptionClick(param: DefinicjeParametrow) {
    this.#spinnerService.show();

    const item = this.footerItems().find((i) => i.param === param);
    if (!item) return;

    this.fetchParamDefinition(param).then((popupInnerHtml) => {
      if (param === DefinicjeParametrow.STRONA_MAPA_SERWISU)
        this.#openMapDialog();
      else this.#openInfoDialog(item.title, popupInnerHtml);
    });
  }

  #openInfoDialog(header: string, content: string): DynamicDialogRef {
    return this.#dialogService.open(InfoDialog, {
      closable: true,
      showHeader: true,
      header: 'Informacyjne okno dialogowe',
      closeOnEscape: true,
      modal: true,
      dismissableMask: true,
      styleClass: 'sr-only-header',
      width: '90vw',
      inputValues: {
        ['header']: header,
        ['content']: content,
        ['hideCancelButton']: true,
      },
      breakpoints: {
        '960px': '90vw',
        '640px': '90vw',
      },
    })!;
  }

  #openMapDialog(): DynamicDialogRef {
    return this.#dialogService.open(InfoDialog, {
      closable: true,
      showHeader: true,
      header: 'Okno dialogowe z mapą serwisu',
      closeOnEscape: true,
      modal: true,
      dismissableMask: true,
      styleClass: 'sr-only-header',
      width: '50vw',
      inputValues: {
        ['header']: 'Mapa serwisu',
        ['component']: SiteMap,
        ['hideCancelButton']: true,
      },
      breakpoints: {
        '960px': '90vw',
        '640px': '90vw',
      },
    })!;
  }
}
